import { CSSProperties, ReactNode } from 'react';
import { withStyles } from 'vopay';
import styles from './DetailsCard.module.scss';

const cn = withStyles(styles);

type DetailsCardProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  'data-testid'?: string;
};

export default function DetailsCard({ children, className, style, 'data-testid': testId }: DetailsCardProps) {
  return (
    <div className={[cn('card'), className].filter(Boolean).join(' ')} style={style} data-testid={testId}>
      {children}
    </div>
  );
}
